import React, { useEffect, useState } from "react";
import { getComplaintTransferTargets } from "../../api/complaints";
import "./ComplaintResponseModal.css";

function targetKey(row) {
  return `${row.role}::${row.id}`;
}

export default function ComplaintTransferModal({
  isOpen,
  onClose,
  onSubmit,
  complaint,
}) {
  const [targets, setTargets] = useState([]);
  const [selectedKey, setSelectedKey] = useState("");
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !complaint?.id) return undefined;

    let cancelled = false;
    setLoading(true);
    setError("");
    setSelectedKey("");
    setReason("");

    getComplaintTransferTargets(complaint.id)
      .then((rows) => {
        if (cancelled) return;
        const list = Array.isArray(rows) ? rows : [];
        setTargets(list);
        if (list.length === 1) {
          setSelectedKey(targetKey(list[0]));
        }
      })
      .catch((err) => {
        if (cancelled) return;
        const message =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "تعذر تحميل المستلمين";
        setError(Array.isArray(message) ? message.join("\n") : message);
        setTargets([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isOpen, complaint?.id]);

  if (!isOpen || !complaint) return null;

  function handleClose() {
    setReason("");
    setError("");
    setSelectedKey("");
    onClose();
  }

  function handleSubmit(e) {
    e.preventDefault();
    const selected = targets.find((t) => targetKey(t) === selectedKey);
    if (!selected) {
      setError("اختر مستلماً");
      return;
    }
    if (!reason.trim() || reason.trim().length < 3) {
      setError("السبب مطلوب");
      return;
    }
    onSubmit({
      targetRole: selected.role,
      targetId: selected.id,
      notes: reason.trim(),
    });
  }

  return (
    <div className="complaint-modal-overlay" onClick={handleClose}>
      <div className="complaint-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="complaint-modal-title">تحويل الشكوى</h3>
        <p className="complaint-modal-subtitle">
          من: {complaint.senderName} — {complaint.title}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="complaint-modal-field">
            <label className="complaint-modal-label">التحويل إلى</label>
            <select
              className="complaint-modal-select"
              value={selectedKey}
              onChange={(e) => setSelectedKey(e.target.value)}
              disabled={loading || targets.length === 0}
            >
              <option value="">
                {loading ? "جاري التحميل..." : "اختر المستلم"}
              </option>
              {targets.map((t) => (
                <option key={targetKey(t)} value={targetKey(t)}>
                  {t.label} — {t.name}
                </option>
              ))}
            </select>
          </div>

          <div className="complaint-modal-field">
            <label className="complaint-modal-label">السبب *</label>
            <textarea
              className={`complaint-modal-textarea ${error ? "has-error" : ""}`}
              rows={4}
              placeholder="اكتب سبب التحويل..."
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (error) setError("");
              }}
            />
            {error && <p className="complaint-modal-error">{error}</p>}
          </div>

          <div className="complaint-modal-buttons">
            <button
              type="button"
              className="complaint-modal-btn secondary"
              onClick={handleClose}
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="complaint-modal-btn primary"
              disabled={loading || targets.length === 0}
            >
              تحويل
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
